import styled from 'styled-components';

export const Wrapper = styled.div`
  .show-more-text,
  &.show-more-text {
    &__icon {
      font-size: 2rem;
      vertical-align: sub;
      transition: transform 0.4s ease-in-out;

      &--opened {
        transform: rotate(180deg);
      }
    }
  }
`;

export default Wrapper;
